export default __webpack_public_path__ + "static/media/people_es.dc4a4b83.png";